import { render, staticRenderFns } from "./BaseTabNav.vue?vue&type=template&id=543d5295&"
import script from "./BaseTabNav.vue?vue&type=script&lang=js&"
export * from "./BaseTabNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports